import { IndicationMap } from '@/model';
import {
  GetIndicationMapByIdResponse,
  GetIndicationMapItemResponse,
  GetLocationResponse,
  PostIndicationMapResponse,
  PutIndicationMapResponse,
} from '@/services/response/location';

export class IndicationMapConverter {
  static toDomainFromPostResponse(response: PostIndicationMapResponse): IndicationMap {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      address: response.address,
      latitude: response.latitude,
      longitude: response.longitude,
      phone_number: response.phone_number,
      email: response.email,
      website: response.website,
      instagram: response.instagram,
      image_url: response.image_url,
      team: response.team,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutIndicationMapResponse): IndicationMap {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      address: response.address,
      latitude: response.latitude,
      longitude: response.longitude,
      phone_number: response.phone_number,
      email: response.email,
      website: response.website,
      instagram: response.instagram,
      image_url: response.image_url,
      team: response.team,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetIndicationMapByIdResponse): IndicationMap {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      address: response.address,
      latitude: response.latitude,
      longitude: response.longitude,
      phone_number: response.phone_number,
      email: response.email,
      website: response.website,
      instagram: response.instagram,
      image_url: response.image_url,
      team: response.team,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromItemResponse(response: GetIndicationMapItemResponse): IndicationMap {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      address: response.address,
      latitude: response.latitude,
      longitude: response.longitude,
      phone_number: response.phone_number,
      email: response.email,
      website: response.website,
      instagram: response.instagram,
      image_url: response.image_url,
      team: response.team,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetLocationResponse): IndicationMap[] {
    return response.data?.map(IndicationMapConverter.toDomainFromItemResponse);
  }
}
